import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';

export const windowScreen = (): string => {
    const windowSize = window.screen.width;
    return  windowSize >= 960 ? 'desktop' : 'mobile';
  }

  @Injectable()
  export class MainMenuToggleService {

    subject = new Subject();
    public isMenuOpen = false;
  
    menuSubject: Subject<boolean> = new Subject<boolean>();

    onMenuToggle() {
      this.isMenuOpen = !this.isMenuOpen
      this.menuSubject.next(this.isMenuOpen);
    }
  }